// Opening book - common chess openings
// FEN position (partial) -> array of possible moves with weights

export const openingBook = {
  // Starting position - heavily favor e4 and d4 as they're the strongest
  "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w": [
    { move: "e2e4", weight: 45, name: "King's Pawn - controls the center!" },
    { move: "d2d4", weight: 45, name: "Queen's Pawn - controls the center!" },
    { move: "g1f3", weight: 8, name: "Réti Opening - develops a knight" },
    { move: "c2c4", weight: 2, name: "English Opening" },
  ],
  
  // After 1. e4
  "rnbqkbnr/pppppppp/8/8/4P3/8/PPPP1PPP/RNBQKBNR b": [
    { move: "e7e5", weight: 45, name: "Fight for the center!" },
    { move: "c7c5", weight: 35, name: "Sicilian Defense - counterattack" },
    { move: "e7e6", weight: 10, name: "French Defense - solid" },
    { move: "c7c6", weight: 10, name: "Caro-Kann Defense - solid" },
  ],
  
  // After 1. d4
  "rnbqkbnr/pppppppp/8/8/3P4/8/PPP1PPPP/RNBQKBNR b": [
    { move: "d7d5", weight: 45, name: "Fight for the center!" },
    { move: "g8f6", weight: 35, name: "Indian Defense - flexible" },
    { move: "e7e6", weight: 15, name: "Solid defense" },
    { move: "c7c5", weight: 5, name: "Benoni - aggressive" },
  ],
  
  // After 1. e4 e5
  "rnbqkbnr/pppp1ppp/8/4p3/4P3/8/PPPP1PPP/RNBQKBNR w": [
    { move: "g1f3", weight: 55, name: "Develop your knight and attack e5!" },
    { move: "f1c4", weight: 25, name: "Italian Game - attack f7!" },
    { move: "b1c3", weight: 15, name: "Vienna Game - develop!" },
    { move: "d2d4", weight: 5, name: "Center Game - open the position" },
  ],
  
  // After 1. e4 e5 2. Nf3
  "rnbqkbnr/pppp1ppp/8/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R b": [
    { move: "b8c6", weight: 60, name: "Knight Defense" },
    { move: "g8f6", weight: 25, name: "Petrov Defense" },
    { move: "d7d6", weight: 10, name: "Philidor Defense" },
    { move: "f7f5", weight: 5, name: "Latvian Gambit" },
  ],
  
  // After 1. e4 e5 2. Nf3 Nc6
  "r1bqkbnr/pppp1ppp/2n5/4p3/4P3/5N2/PPPP1PPP/RNBQKB1R w": [
    { move: "f1b5", weight: 40, name: "Ruy Lopez" },
    { move: "f1c4", weight: 30, name: "Italian Game" },
    { move: "d2d4", weight: 20, name: "Scotch Game" },
    { move: "b1c3", weight: 10, name: "Four Knights" },
  ],
  
  // After 1. e4 c5 (Sicilian)
  "rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w": [
    { move: "g1f3", weight: 50, name: "Open Sicilian" },
    { move: "b1c3", weight: 20, name: "Closed Sicilian" },
    { move: "c2c3", weight: 15, name: "Alapin Variation" },
    { move: "f1c4", weight: 10, name: "Bowdler Attack" },
    { move: "d2d4", weight: 5, name: "Smith-Morra Gambit" },
  ],
  
  // After 1. d4 d5
  "rnbqkbnr/ppp1pppp/8/3p4/3P4/8/PPP1PPPP/RNBQKBNR w": [
    { move: "c2c4", weight: 50, name: "Queen's Gambit" },
    { move: "g1f3", weight: 25, name: "Queen's Pawn" },
    { move: "b1c3", weight: 15, name: "Veresov Attack" },
    { move: "c1f4", weight: 10, name: "London System" },
  ],
  
  // After 1. d4 Nf6
  "rnbqkb1r/pppppppp/5n2/8/3P4/8/PPP1PPPP/RNBQKBNR w": [
    { move: "c2c4", weight: 45, name: "Indian Game" },
    { move: "g1f3", weight: 30, name: "Indian Defense" },
    { move: "c1f4", weight: 15, name: "London System" },
    { move: "b1c3", weight: 10, name: "Richter-Veresov" },
  ],
  
  // Queen's Gambit Declined
  "rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b": [
    { move: "e7e6", weight: 40, name: "Queen's Gambit Declined" },
    { move: "d5c4", weight: 30, name: "Queen's Gambit Accepted" },
    { move: "c7c6", weight: 20, name: "Slav Defense" },
    { move: "g8f6", weight: 10, name: "Indian Response" },
  ],
  
  // Italian Game
  "r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b": [
    { move: "f8c5", weight: 45, name: "Giuoco Piano" },
    { move: "g8f6", weight: 35, name: "Two Knights" },
    { move: "f8e7", weight: 15, name: "Hungarian Defense" },
    { move: "d7d6", weight: 5, name: "Philidor Position" },
  ],
  
  // Ruy Lopez
  "r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b": [
    { move: "a7a6", weight: 50, name: "Morphy Defense" },
    { move: "g8f6", weight: 25, name: "Berlin Defense" },
    { move: "f8c5", weight: 15, name: "Classical Defense" },
    { move: "d7d6", weight: 10, name: "Old Steinitz" },
  ],
  
  // French Defense
  "rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w": [
    { move: "d2d4", weight: 60, name: "French Main Line" },
    { move: "d2d3", weight: 20, name: "King's Indian Attack" },
    { move: "b1c3", weight: 15, name: "Paulsen Attack" },
    { move: "g1f3", weight: 5, name: "Knight Attack" },
  ],
  
  // Caro-Kann
  "rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w": [
    { move: "d2d4", weight: 50, name: "Main Line" },
    { move: "b1c3", weight: 25, name: "Two Knights" },
    { move: "d2d3", weight: 15, name: "King's Indian" },
    { move: "g1f3", weight: 10, name: "Exchange Variation" },
  ],
};

// Get a book move for the given position
// IMPORTANT: Must pass chess.js game instance to validate moves
export function getBookMove(fen, game = null) {
  // Simplify FEN for lookup (remove move counters)
  const parts = fen.split(' ');
  const lookupKey = parts[0] + ' ' + parts[1];
  
  const moves = openingBook[lookupKey];
  if (!moves || moves.length === 0) return null;
  
  // Filter to only include legal moves if game instance provided
  let validMoves = moves;
  if (game) {
    const legalMoves = game.moves({ verbose: true });
    validMoves = moves.filter(bookMove => {
      const from = bookMove.move.slice(0, 2);
      const to = bookMove.move.slice(2, 4);
      return legalMoves.some(legal => legal.from === from && legal.to === to);
    });
    
    if (validMoves.length === 0) return null;
  }
  
  // Weighted random selection
  const totalWeight = validMoves.reduce((sum, m) => sum + m.weight, 0);
  let random = Math.random() * totalWeight;
  
  for (const move of validMoves) {
    random -= move.weight;
    if (random <= 0) {
      return {
        from: move.move.slice(0, 2),
        to: move.move.slice(2, 4),
        name: move.name
      };
    }
  }
  
  return null;
}

// Check if position is in opening book
export function isInBook(fen) {
  const parts = fen.split(' ');
  const lookupKey = parts[0] + ' ' + parts[1];
  return lookupKey in openingBook;
}
